module.exports = __webpack_public_path__ + "../resources/images/illustration_trash-7300c94ec70ffefd6bd58170d635726b.svg";